import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { GrantType } from 'src/app/shared/enums/grant-type.enum';
import { CedenteService } from 'src/app/services/cedente.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { Login } from 'src/app/models/login';
import { LoginService } from 'src/app/services/login.service';
import { Assignors, Auth } from 'src/app/models/auth';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
  selector: 'app-login-pin',
  templateUrl: './login-pin.component.html',
  styleUrls: ['./login-pin.component.css']
})
export class LoginPinComponent implements OnInit {

  public loginPinFormGroup: FormGroup;
  private currentLogin: Login;
  private currentUser: Auth;

  constructor(
    private formBuilder: FormBuilder, private authenticationService: AuthenticationService, private loginService: LoginService,
    private cedenteService: CedenteService, private alertService: NewAlertService, private router: Router) { }

  ngOnInit() {
    this.loginService.currentLogin.subscribe(response => this.currentLogin = response);
    this.authenticationService.currentUser.subscribe(response => this.currentUser = response);

    if (this.currentUser === null) {
      this.router.navigate(['auth']);
    }

    this.loginPinFormGroup = this.formBuilder.group({
      pin: new FormControl('', [
        Validators.required,
        Validators.maxLength(6)
      ])
    });
  }

  get form() { return this.loginPinFormGroup.controls; }

  onSubmit(login: any) {
    const cedente = this.currentUser.assignors.find(x=>x.selected == true);
    if (this.loginPinFormGroup.valid) {
      this.authenticationService.newlogin(3, login.pin, cedente.transitoryToken).subscribe(
        response => {
          if (response.status === ApiError.Sucesso) {
            response.result.token.isAnonymous = false;
            response.result.assignors = [];
            this.currentUser.assignors.forEach(element => {response.result.assignors.push(new Assignors)});
            this.authenticationService.setCurrentUserValue(response.result);
            this.router.navigate(['portal/home']);
          } else {
            this.alertService.error('PIN inválido, tente novamente');
          }
        }
      );
    }
  }

  login() {
    this.router.navigate(['auth']);
  }

  sendPin() {
    const cedente = this.currentUser.assignors.find(x=>x.selected == true);
    this.authenticationService.newlogin(2,cedente.hasPin, cedente.transitoryToken).subscribe(
      response => {
        this.alertService.success('Pin enviado para o e-mail e/ou SMS');
      },
      error => {
        this.alertService.error('Ocorreu um erro ao enviar o pin, tente novamente mais tarde.');
      }
    );
  }
}
